let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("sSJpO")).then(() => parcelRequire('ffGm1'));